import { infiniteQueryOptions, queryOptions, useSuspenseInfiniteQuery } from '@tanstack/react-query'

import { activityFeedClient, EntityFeedPageParams } from './feed.service'
import { ACTIVITY_FILTERS } from '../domain/feed'
import { useActivityFeedFilter } from '../hooks'
export const GET_FEEDS_API_UNIQUE_KEY = 'activity-feed'
export const GET_FEEDS_API_INFINITE_UNIQUE_KEY = 'activity-feed-infinite'

export const defaultFeedPageParams: EntityFeedPageParams = {
  orderByDesc: 'true',
  page: 1,
  pageSize: 20,
  entityID: [],
}

export const entityFeedQueryOptions = (queryParams?: Partial<EntityFeedPageParams>) => {
  const pageParam: EntityFeedPageParams = {
    ...defaultFeedPageParams,
    ...queryParams,
  }
  return queryOptions({
    queryKey: [GET_FEEDS_API_UNIQUE_KEY, pageParam],
    queryFn: () => activityFeedClient.getEntityFeed({ pageParam }),
    enabled: !!pageParam.entityID.length,
  })
}

export const entityFeedInfiniteQueryOptions = (queryParams?: Partial<EntityFeedPageParams>, enabled = true) => {
  const initialPageParams: EntityFeedPageParams = {
    ...defaultFeedPageParams,
    ...queryParams,
  }
  return infiniteQueryOptions({
    queryKey: [GET_FEEDS_API_INFINITE_UNIQUE_KEY, queryParams],
    queryFn: activityFeedClient.getEntityFeed,
    initialPageParam: initialPageParams,
    getNextPageParam: (lastPage, allPages, lastPageParam): EntityFeedPageParams | undefined => {
      const isNextPagePresent = allPages.length * lastPageParam.pageSize < lastPage.total
      return isNextPagePresent ? { ...initialPageParams, page: lastPageParam.page + 1 } : undefined
    },
    getPreviousPageParam: () => undefined,
    placeholderData: (prev) => prev,
    enabled,
  })
}

export const useEntityActivityFeed = (queryParams?: Partial<EntityFeedPageParams>) => {
  const { activityType } = useActivityFeedFilter()
  return useSuspenseInfiniteQuery(
    entityFeedInfiniteQueryOptions({
      ...queryParams,
      activityTypes: activityType ? ACTIVITY_FILTERS[activityType] : undefined,
    })
  )
}
